export default __webpack_public_path__ + "static/media/title_bg.04541746.svg";